export default {
    isGridOpen: state => state.gridIsOpen,
    isFormOpen: state => state.formIsOpen,
    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getSearchFields: state => state.searchFields,
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
}
